/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_TypeInputs */

const en_admin_resources_resource_allocations_type = /** @type {(inputs: Admin_Resources_Resource_Allocations_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_admin_resources_resource_allocations_type = /** @type {(inputs: Admin_Resources_Resource_Allocations_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art`)
};

const es_admin_resources_resource_allocations_type = /** @type {(inputs: Admin_Resources_Resource_Allocations_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const fr_admin_resources_resource_allocations_type = /** @type {(inputs: Admin_Resources_Resource_Allocations_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_TypeInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_type = en_admin_resources_resource_allocations_type;

/** @type {(inputs: Admin_Resources_Resource_Allocations_TypeInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_type = en_admin_resources_resource_allocations_type;

/** @type {(inputs: Admin_Resources_Resource_Allocations_TypeInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_type = en_admin_resources_resource_allocations_type;

/** @type {(inputs: Admin_Resources_Resource_Allocations_TypeInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_type = en_admin_resources_resource_allocations_type;

/** @type {(inputs: Admin_Resources_Resource_Allocations_TypeInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_type = en_admin_resources_resource_allocations_type;

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Admin_Resources_Resource_Allocations_TypeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_type = /** @type {((inputs?: Admin_Resources_Resource_Allocations_TypeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_TypeInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_type(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_type(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_type(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_type(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_type(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_type(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_type(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_type(inputs)
	return ro_admin_resources_resource_allocations_type(inputs)
});
export { admin_resources_resource_allocations_type as "admin.resources.resource_allocations.type" }